import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LuFolderSync, LuCopyX, LuCopyPlus, LuCopy } from 'react-icons/lu';
import is from 'is_js';
const UnitedIcon = ({ icon, ...other }) => {
  if (is.string(icon)) {
    switch (icon) {
      case 'LuFolderSync':
        return <LuFolderSync {...other} />;
      case 'LuCopyX':
        return <LuCopyX {...other} />;
      case 'LuCopyPlus':
        return <LuCopyPlus {...other} />;
      case 'LuCopy':
        return <LuCopy {...other} />;
      default:
        //Warning: Failed prop type: Invalid prop `size` of value `20` supplied to `FontAwesomeIcon`, expected one of ["2xs","xs","sm","lg","xl","2xl","1x","2x","3x","4x","5x","6x","7x","8x","9x","10x"].
        if (is.number(other.size)) {
          delete other.size;
        }
        return <FontAwesomeIcon icon={icon} {...other} />;
    }
  }
  return <FontAwesomeIcon icon={icon} {...other} />;
};

UnitedIcon.propTypes = {
  icon: PropTypes.any
};

export default UnitedIcon;
